import styled from 'styled-components'

export default styled.h1`
  font: 600 ${props => (props.smaller ? '27.5px/35px' : '44px/56px')}
      'chaparral-pro',
    serif;
  color: #000;
  margin: 0 0 30px 0;
  text-align: ${props => (props.smaller ? 'left' : 'center')};
`



// WEBPACK FOOTER //
// ./components/atoms/header.js